import './spinner.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Spinner = forwardRef((props, ref) => {
  const className = classNames({
    [`spinner-${props.appearance}`]: true,
    [`text-${props.theme}`]: true,
    [`spinner-${props.appearance}-${props.size}`]: props.size,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className} role="status">
      {props.children}
    </div>
  );
});

Spinner.propTypes = {
  appearance: PropTypes.oneOf(['grow', 'border']),
  theme: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'white']),
  size: PropTypes.oneOf(['sm']),
  children: PropTypes.node,
  className: PropTypes.string,
};

Spinner.defaultProps = {
  appearance: 'border',
  theme: 'primary',
};

export default Spinner;
